module.exports = __webpack_public_path__ + "static/img/stage-mode-2.49fbaaa3.png";